import * as Types from '../types/upload';

export const uploadAction = (filters) => ({type: Types.UPLOAD_ACTION, filters});
export const uploadSuccess = (files) => ({
    type: Types.UPLOAD_SUCCESS,
    files
});
export const uploadInitStore = (params) => ({type: Types.UPLOAD_INIT, params});
export const uploadClearStore = (params) => ({type: Types.UPLOAD_FAIL, params});
